// ============================================================================
// RendererV1 palette — the DESIGN TEAM's theme (Polygon Health Trends Redesign
// *.dc.html). 2026-07-13: the rest of HW adopted this palette by redefining
// healthWalletConstants BRAND_* to these values, so V1 now just re-exports the
// shared constants — one source of truth, no drift.
// ============================================================================
import { BRAND, BRAND_DARK, BRAND_DARKER } from '../healthWalletConstants';

export const V1_ACCENT = BRAND_DARKER;      // #6c4ce0 — primary accent (active pills, links, icons)
export const V1_ACCENT_TINT = BRAND;        // #efeaff — accent surface (info box, disabled tile, hovers)
export const V1_ACCENT_BORDER = BRAND_DARK; // #d7d3f0 — accent-tinted borders (hero/section cards)
